import { MenuItem } from '@chakra-ui/react'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useCommercialBudget from '@hook/budget/use-commercial'
import useTools from '@hook/shared/use-tools'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'
const ActionExcelCommercialConsolidatedExport: FC<ILayoutToolsExportAction> =
  () => {
    const { isDisabled } = useTools()
    const { exportDataConsolidated } = useCommercialBudget()
    return (
      <MenuItem
        p="2px 12px"
        fontSize="sm"
        bgColor="white"
        _hover={{ bg: 'gray.400' }}
        isDisabled={isDisabled}
        onClick={exportDataConsolidated}
        icon={<GrDocumentCsv />}
      >
        Exportar Consolidado para CSV
      </MenuItem>
    )
  }

export default ActionExcelCommercialConsolidatedExport
